export default "__VITE_ASSET__DUbsPAW3__"